import styled from 'styled-components';
import { GREY_500, WHITE } from '../../../constants';

export const StyledWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 100%;
    background: ${WHITE};
`;

export const StyledDocumentWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
    padding: 1.5rem;
    overflow: hidden;

    .react-pdf__Page {
        background: ${WHITE};
        box-shadow:
            0 0 1px rgba(15, 23, 42, 0.1),
            0 8px 24px rgba(15, 23, 42, 0.08),
            0 20px 48px rgba(15, 23, 42, 0.06);
    }

    .react-pdf__Page canvas {
        display: block;
    }
`;

export const StyledMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 100%;
    padding: 2rem;
    color: ${GREY_500};
    font-size: 0.875rem;
`;

export const StyledNavigator = styled.div`
    position: absolute;
    left: 50%;
    bottom: 1.25rem;
    z-index: 2;
    display: flex;
    align-items: center;
    transform: translateX(-50%);
    padding: 0.2rem 0.45rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.1);
`;

export const StyledPageButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 1.75rem;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${GREY_500};
    font-size: 0.875rem;
    line-height: 1;
    cursor: pointer;

    &:disabled {
        opacity: 0.35;
        cursor: default;
    }
`;

export const StyledPageIndicator = styled.span`
    min-width: 2rem;
    color: ${GREY_500};
    font-size: 0.8125rem;
    font-weight: 500;
    text-align: center;
`;
